import React, { useLayoutEffect, useState } from "react"
import { useLocation } from "react-router-dom";
import {
    Icon,
    Panel,
    Header,
    Navbar,
    Content,
    Container,
    FlexboxGrid,
} from "rsuite";
import styled, { keyframes } from "styled-components";

import {
    ACCOUNT_USER_LOGIN_MASTER_API,
    SUBACC_LOGIN_USER_METHOD,
    ACCOUNT_USER_LOGIN_MASTER_PANEL_METHOD
} from "const/apiMethods";
import { DEFAULT_AUTH_PATH_ADMIN } from "const";
import history from "config/history";
import { api } from "api/loginRoutes";


export default () => {
    const location = useLocation();
    const [title, setTitle] = useState("Redirecting...");
    const icon = "refresh2";

    useLayoutEffect(() => {
        let active = true;

        const redirectBySession = async () => {
            const searchParams = new URLSearchParams(location.search);

            const customerId = searchParams.get("customer-id");
            const subCustomerId = searchParams.get("sub-customer-id");
            const userId = searchParams.get("user-id");

            if (!customerId && !subCustomerId && !userId) {
                history.push(DEFAULT_AUTH_PATH_ADMIN);
                return;
            }

            const handlers = [
                [customerId, ACCOUNT_USER_LOGIN_MASTER_API],
                [subCustomerId, SUBACC_LOGIN_USER_METHOD],
                [userId, ACCOUNT_USER_LOGIN_MASTER_PANEL_METHOD],
            ];

            const [id, method] = handlers.find(([handlerId]) => handlerId != null) || [];
            const isSubCustomer = method === SUBACC_LOGIN_USER_METHOD;
            const isPanelUser = method === ACCOUNT_USER_LOGIN_MASTER_PANEL_METHOD;
            const params = !isSubCustomer
                ? { target: { account_user_id: id } }
                : { target: { subacc_user_id: id } };

            const response = await api(method, params);

            if (!active) {
                return;
            }

            if (!isSubCustomer) {
                const sessionKey = response?.session?.session_key;

                if (!sessionKey) {
                    setTitle("Redirection failed");
                    return;
                }

                const loginOrigin = isPanelUser // || process.env.NODE_ENV === "development"
                    ? window.location.origin
                    : process.env.REACT_APP_CLIENT_URL;

                window.location.href = `${loginOrigin}/login?session-key=${encodeURIComponent(sessionKey)}`;
                return;
            }

            const sessionId = response?.session_id;
            const host = response?.host;

            if (!sessionId || !host) {
                setTitle("Redirection failed");
                return;
            }

            window.location.href = `https://${host}/login?session-id=${encodeURIComponent(sessionId)}`;
        };

        redirectBySession();

        return () => {
            active = false;
        };
    }, [location.search]);

    return (
        <StyledContainer>

            <Header>
                <Navbar appearance="inverse">
                    <Navbar.Body style={{ minHeight: 56 }}>
                    </Navbar.Body>
                </Navbar>
            </Header>

            <Content>
                <FlexboxGrid justify="center" style={{ width: "100%" }}>
                    <FlexboxGrid.Item
                        style={{
                            marginTop: "20vh",
                            width: "100%",
                            maxWidth: "500px",
                            minWidth: "340px",
                            opacity: 0.7,
                        }}
                    >
                        <Panel
                            className="panel__noShadow"
                            header={<h3>{title}</h3>}
                            style={{
                                width: "100%",
                                textAlign: "center",
                            }}
                        >
                            <StyledIcon
                                icon={icon}
                                size="5x"
                            />
                        </Panel>
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </Content>
        </StyledContainer>
    );
};


const StyledContainer = styled(Container)`
    min-height: 100vh;
`;


const rotate = keyframes`
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
`;

const StyledIcon = styled(Icon)`
    display: block;
    animation: ${rotate} 2s linear infinite;
`;
